import { render, staticRenderFns } from "./areaHandle.vue?vue&type=template&id=5231c71d&scoped=true&"
import script from "./areaHandle.vue?vue&type=script&lang=js&"
export * from "./areaHandle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5231c71d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/suifeng/Desktop/projects/2022/sdSdm/sdSdmAdmin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5231c71d')) {
      api.createRecord('5231c71d', component.options)
    } else {
      api.reload('5231c71d', component.options)
    }
    module.hot.accept("./areaHandle.vue?vue&type=template&id=5231c71d&scoped=true&", function () {
      api.rerender('5231c71d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pages/member/memberAreaApply/areaHandle.vue"
export default component.exports